export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7776.da71754d.jpg";